<template>
<div class="loader-box"  :class="{'inline':type=='inline'}" v-if="show">
    <div class="loader">
        <div class="icon"></div>
    </div>
</div>
</template>

<script>
export default {
    name: "Loader",
    props:['show','type'],
    
};
</script>

<style scoped>
.loader-box {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0,0,0,0.05);
    top: 0px;
    left: 0px;
    z-index: 2500;
    display: flex;
    justify-content:center;
    align-items: center;
}
.loader-box.inline{
    height: 600px;
    position: relative;
    background-color: transparent;
}
.loader{
    margin: auto;
    background-color: #fff;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    justify-content:center;
    align-items: center; 
}
.icon{
    width: 42px;
    height: 42px;
    background: url(../assets/img/loader.gif);
    background-size: contain;
    opacity: 0.5;
}
</style>
